'use strict';

/**
 *
 * @name: ddPlaylist
 *
 */

import DirectiveTemplate from './nn-dropdown-playlist.directive.html';

function NnDropdownPlaylistDirective(Playlist, $rootScope, transObject, $timeout) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      post: '=',
      showPlaylist: '=',
      toggleDd: '='
    },
    link: function (scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      var rootWatchers = {};
      var page = 1;
      scope.isLoading = false;
      scope.playlists = [];
      scope.ddPlaylistHelper = {
        isPublic: true,
      };
      scope.newPlaylist = {
        title: '',
        isPrivate: false
      };
      scope.loadedAll = false;
      /**
       *
       * @PUBLIC_METHODS
       *
       */


      scope.createNewPlaylist = function () {

        var newPlaylist = new Playlist();

        newPlaylist.translations = [{
          language: $rootScope.lang,
          title: scope.newPlaylist.title
        }];
        newPlaylist.isPrivate = scope.newPlaylist.isPrivate;
        newPlaylist.type = 'memberPlaylist';
        newPlaylist.UserId = $rootScope.profile.id;

        newPlaylist
          .$save()
          .then(function (res) {

            scope.ddPlaylistHelper.isPublic = true;
            scope.newPlaylist = {
              title: '',
              isPrivate: false,
            };
            transObject.translate(res);
            res.videosCount = 0;
            scope.playlists.push(res);
            scope.addPostToPlaylist(scope.playlists.length - 1);
          });
      };

      scope.addPostToPlaylist = function (index) {

        if (!scope.playlists[index].containsPost) {

          Playlist
            .addStory({
              id: scope.playlists[index].id,
              postId: scope.post.id
            }).$promise
            .then(function () {

              scope.playlists[index].containsPost = true;
              scope.playlists[index].newPost = true;
              $timeout(function () {

                scope.playlists[index].newPost = false;
              }, 1508);

              if (scope.playlists[index].videosCount === 0) {

                scope.playlists[index].thumbnailUrl = scope.post.thumbnailUrl;
                element.find('.ucp-playlist-list li:eq(' + index + ')').addClass('wide-thumb');
              }

              scope.playlists[index].videosCount++;
            });
        } else {

          Playlist
            .deleteStory({
              id: scope.playlists[index].id,
              postId: scope.post.id
            }).$promise
            .then(function (res) {

              scope.playlists[index].containsPost = false;
              scope.playlists[index].videosCount--;
              if (res.coverDeleted) {
                scope.playlists[index].coverUrl = null;
                scope.playlists[index].imageUrl = null;
                scope.playlists[index].thumbnailUrl = null;
              }
            });
        }
      };

      scope.loadMore = function () {

        if (!scope.isLoading && !scope.loadedAll) {

          page++;

          loadPlaylists();
        }
      };
      /**
       *
       * @PRIVATE_METHODS
       *
       */


      function loadPlaylists() {

        scope.isLoading = true;
        Playlist
          .get({
            UserId: $rootScope.profile.id,
            containsPost: scope.post.id,
            order: 'createdAt asc',
            page: page
          }).$promise
          .then(function (res) {

            res.items.forEach(function (item) {
              transObject.translate(item);
              scope.playlists.push(item);
            });

            scope.isLoading = false;
            scope.loadedAll = (page === res.meta.totalPages);
          });
      }

      function runPlaylists() {

        if ($rootScope.profile) {

          loadPlaylists();
        } else {

          rootWatchers.profile = $rootScope.$watch('profile', function (newVal, oldVal) {

            if (newVal && !oldVal) {

              rootWatchers.profile();
              loadPlaylists();
            }
          });
        }
      }

      /**
       *
       * @INIT
       *
       */

      var playlistGoCompile = $rootScope.$on('goCompile', function () {

        setTimeout(function () {

          scope.$apply(function () {

            runPlaylists();
          });
        }, 1);
      });

      var watchShowPlaylist = scope.$watch('showPlaylist', function (newVal) {

        if (newVal === true) {

          $(element).slideDown(250);

        } else {

          $(element).slideUp(250);
        }
      });

      runPlaylists();

      scope.$on('$destroy', function () {

        playlistGoCompile();
        watchShowPlaylist();

        Object.keys(rootWatchers)
          .forEach(function (killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });

        element.find('*').remove();
      });
    }
  };
}

export default NnDropdownPlaylistDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-dropdown-playlist/nn-dropdown-playlist.directive.js